module.exports = __webpack_public_path__ + "static/img/tiancheng02_hq.6d57a3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tiancheng02_hq.png
// module id = 1053
// module chunks = 1